import { TBPTCReconfirmationPartner } from 'onboarding/classes/services/api/OnboardingBPTCReconfirmationApi'

import styles from './PartnerDataSection.module.scss'

interface IProps {
  partner: TBPTCReconfirmationPartner | null
  texts: {
    partnerIdText: string
    companyText: string
    vatIDText: string
  }
}

export const BPTCReconfirmationPartnerDataSection: React.FC<IProps> = ({
  partner,
  texts: { partnerIdText, companyText, vatIDText },
}) => {
  if (!partner) {
    return null
  }

  return (
    <section className={styles.partnerSection}>
      <h2 className={styles.sectionTitle}>Partner Information</h2>
      <div className={styles.partnerGrid}>
        <div className={styles.leftCol}>
          <div className={styles.row}>
            <span className={styles.label}>{partnerIdText}:</span>
            <span className={styles.value}>{partner.partnerId}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>{companyText}:</span>
            <span className={styles.value}>{partner.tradingName}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>{vatIDText}:</span>
            <span className={styles.value}>{partner.taxId}</span>
          </div>
        </div>

        <div className={styles.rightCol}>
          <span className={styles.label}>Address:</span>
          <div className={styles.addressDetails}>
            <div>{partner.address.address1}</div>
            <div>
              {partner.address.zip} {partner.address.city}
            </div>
            <div>{partner.address.countryName}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
